import { createAction } from "redux-actions";
import { LoginConstants } from "../constants/login.constants";

export const login = createAction(LoginConstants.LOGIN);
export const loginSuccess = createAction(LoginConstants.LOGIN_SUCCESS);
export const loginFailure = createAction(LoginConstants.LOGIN_FAILURE);

export const logout = createAction(LoginConstants.LOGOUT);
export const receivedIdToken = createAction(LoginConstants.RECEIVED_ID_TOKEN);
export const receivedApiToken = createAction(LoginConstants.RECEIVED_API_TOKEN);
export const checkApiToken = createAction(LoginConstants.CHECK_API_TOKEN);

export const updateUserSettings = createAction(
    LoginConstants.UPDATE_USER_SETTINGS
);
export const initiateLoginCheck = createAction(
    LoginConstants.INITIATE_LOGIN_CHECK
);



// WEBPACK FOOTER //
// ./src/actions/login.actions.js